import "./static/fonts/fonts.css"

const wrapRootElement = ({ element }) => element

export { wrapRootElement }
